import './layout.less'

import React from 'react'
import {PageData} from 'types'
import useRouter from 'use-react-router'
import {CMSLink} from 'util/cmslink'
import {useEvent} from 'util/eventcontext'
import {useIsDark, useSearchParams} from 'util/hooks'
import {style} from 'util/style'
import {Tracking} from 'util/tracking'
import {Cookiewarning} from 'views/layout/cookiewarning'
import {Footer} from 'views/layout/footer'
import {GridProvider} from 'views/layout/grid'
import {Header} from 'views/layout/header'
import {ProgramPopup} from 'views/program/programpopup'

const styles = style('layout')

export const Layout: React.FC<{page: PageData}> = attrs => {
	const {page, children} = attrs
	const router = useRouter()
	const event = useEvent()
	const {popup} = useSearchParams()
	const directLinkItem = event.program.getProgramItemByDirectLink(
		router.location.pathname
	)
	const item = event.program.getProgramItem(popup)
	const isDark = useIsDark()

	return (
		<GridProvider
			xxs={{gap: [5, 30]}}
			xs={{gap: [5, 30]}}
			s={{gap: [15, 30]}}
			m={{gap: [15, 30]}}
			gap={[30, 30]}
		>
			<div class={styles().mod({dark: isDark})}>
				<CMSLink id={page.id} project={page.project_key} />
				<ProgramPopup program={event.program} item={directLinkItem || item} />
				<Header event={event} />
				<div class={styles('content')}>{children}</div>
				<Footer pageurl={page && page.url} event={event} />
				<Tracking view={Cookiewarning} project={page.project_key} />
			</div>
		</GridProvider>
	)
}
